import React from 'react';
import { Sparkles, ArrowLeft } from 'lucide-react';
import { Card, Button, Badge } from '../ui';
import { findNav } from '../nav';

export const ComingSoon = ({ view, go }) => {
  const parts = view.split('/');
  const nav = findNav(parts[1] || '');
  const sub = parts[2];
  const Icon = nav.icon;
  return (
    <div className="max-w-3xl mx-auto pt-8" data-testid="erp-coming-soon">
      <Card className="p-10 text-center erp-rise relative overflow-hidden">
        <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full" style={{ background: 'var(--erp-blue-soft)' }} />
        <div className="relative">
          <span className="mx-auto h-16 w-16 rounded-2xl grid place-items-center text-white mb-5" style={{ background: 'linear-gradient(160deg, #2452c9, #0b1a4a)' }}><Icon size={28} /></span>
          <Badge tone="blue" className="mb-3"><Sparkles size={12} /> Phase 2</Badge>
          <h1 className="text-3xl font-extrabold tracking-tight">{nav.label}{sub ? ` · ${sub}` : ''}</h1>
          <p className="mt-3 text-base max-w-lg mx-auto" style={{ color: 'var(--erp-muted)' }}>
            This module is scheduled for Phase 2 of the Namoh ERP rollout. Masters, inventory and access control from Phase 1 already power it.
          </p>
          {Array.isArray(nav.children) && (
            <div className="flex flex-wrap justify-center gap-2 mt-6">
              {nav.children.map((c) => <span key={typeof c === 'string' ? c : c.key} className="text-sm px-3 py-1.5 rounded-lg font-semibold" style={{ background: '#f3f6fb', color: '#3b4664' }}>{typeof c === 'string' ? c : c.label}</span>)}
            </div>
          )}
          <Button variant="ghost" icon={ArrowLeft} className="mt-8" onClick={() => go('dashboard')} data-testid="coming-soon-back">Back to Dashboard</Button>
        </div>
      </Card>
    </div>
  );
};
